/**
 * Turns an RTK-Query auth error into copy a user can actually act on.
 *
 * The real backend sometimes returns its own message verbatim (e.g.
 * "Invalid or expired OTP") which is fine to show as-is — but a handful of
 * status codes mean something the raw message doesn't communicate well:
 * a 404 here means the *route itself* isn't available server-side (this
 * API is still being filled in — see the docs' own "not yet populated"
 * notes), not that whatever the user typed was "not found". Passing that
 * straight through reads as a bug in the OTP/email/etc. the person just
 * entered, when it's actually nothing they did.
 */
export function authErrorMessage(err, overrides = {}) {
  const status = err?.status;

  if (status === undefined || status === 'FETCH_ERROR') {
    return overrides.network || "Couldn't reach the server. Check your connection and try again.";
  }
  if (status === 404) {
    return overrides.notFound || "This isn't available right now — please try again in a bit.";
  }
  if (status === 403) {
    return overrides.forbidden || err?.data?.message || "Your account doesn't have permission to do this.";
  }
  if (status === 429) {
    return overrides.tooMany || 'Too many attempts. Please wait a moment and try again.';
  }
  if (status >= 500) {
    return overrides.server || 'The server hit a snag on its end. Please try again shortly.';
  }

  return err?.data?.message || overrides.fallback || 'Something went wrong. Please try again.';
}

export default authErrorMessage;
